// extracted by mini-css-extract-plugin
module.exports = {"mainPrivacyPolicyCard":"PrivacyPolicyIntroductionPage_mainPrivacyPolicyCard__22ejN","mainPrivacyPolicyContainer":"PrivacyPolicyIntroductionPage_mainPrivacyPolicyContainer__2ghIz"};